"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const authProvider_1 = require("@/components/authProvider/authProvider");
const formatDate_1 = require("@/utils/formatDate");
const react_router_dom_1 = require("react-router-dom");
const Section_1 = require("@/components/Section");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const Chip_1 = require("@/components/Chip");
const styledComponents_1 = require("@/components/styledComponents");
const commands = {
    SetXDRRatio: "Set XDR Ratio",
    Motion: "Motion",
    SetGovMode: "Change Governance Mode",
    CanisterOversight: "Canister Oversight",
    SendSysFunds: "Send System Funds"
};
const topics = {
    SetXDRRatio: "XDR Ratio",
    Motion: "Motion",
    SetGovMode: "Change Governance Mode",
    CanisterOversight: "Canister Oversight",
    SendSysFunds: "Send System Funds"
};
const statuses = {
    Passed: "Passed",
    Open: "Open",
    NoQuorum: "No Quorum"
};
const cells = [
    { id: "id", label: "Proposal ID" },
    { id: "title", label: "Title" },
    { id: "proposed", label: "Proposed" },
    { id: "timeRemaining", label: "Time Remaining" },
    { id: "topic", label: "Topic" },
    { id: "status", label: "Status" },
    { id: "actions", label: "Actions" },
];
const ProposalBlock = ({ proposal, index }) => {
    const [isOpened, setIsOpened] = (0, react_1.useState)(false);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(origyn_art_ui_1.Banner, { key: index, style: { width: '100%' }, padding: '12px', bgColor: index % 2 ? 'BACKGROUND' : 'BORDER', flexFlow: 'column' },
            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", style: { wordBreak: 'break-all' } },
                react_1.default.createElement("div", { style: { cursor: 'pointer', padding: '4px' }, onClick: () => setIsOpened(!isOpened) },
                    react_1.default.createElement(origyn_art_ui_1.Icons.ArrowDownIcon, { style: { transform: `rotate(${isOpened ? "180deg" : "0deg"})` } })),
                react_1.default.createElement(origyn_art_ui_1.Grid, { style: { marginLeft: 30, width: '100%', minWidth: 900 }, smColumns: cells.length, mdColumns: cells.length, columns: cells.length }, cells.map((c) => react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center" }, proposal[c.id])))),
            isOpened && (react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16, style: { padding: "12px 12px 12px 50px" } },
                react_1.default.createElement("p", null,
                    "Proposer: ",
                    react_1.default.createElement("b", null, proposal.data?.proposer.toString())),
                react_1.default.createElement("p", null,
                    "Risked OGY: ",
                    react_1.default.createElement("b", null, proposal.data?.risked_ogy.toString())),
                react_1.default.createElement("p", null,
                    "For Votes: ",
                    react_1.default.createElement("b", null, proposal.data?.for_votes.toString())),
                react_1.default.createElement("p", null,
                    "Against Votes: ",
                    react_1.default.createElement("b", null, proposal.data?.for_votes.toString())),
                proposal.data?.command_type?.SendSysFunds ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", null,
                        "Proposal description: ",
                        react_1.default.createElement("b", null, decodeURI(proposal.data?.command_type?.SendSysFunds?.text))),
                    react_1.default.createElement("p", null,
                        "CanisterID: ",
                        react_1.default.createElement("b", null, proposal.data?.command_type?.SendSysFunds?.canister.toString()))) : ""))));
};
const Proposals = () => {
    const { principal, accountID, ledgerActor, governanceActor } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [proposals, setProposals] = (0, react_1.useState)([]);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [pages, setPages] = (0, react_1.useState)(0);
    const [onlyOpened, setOnlyOpened] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const getProposals = async () => {
        if (isLoading)
            return;
        setIsLoading(true);
        console.log(onlyOpened ? 2000 : 20, onlyOpened ? 0 : pages - (currentPage - 1), onlyOpened ? [{ open: null }] : []);
        let proposals = (await governanceActor.get_proposals(onlyOpened ? 2000 : 20, onlyOpened ? 0 : pages - (currentPage - 1), onlyOpened ? [{ open: null }] : []));
        console.log(proposals);
        if (proposals.length === 0) {
            proposals = (await governanceActor.get_proposals(onlyOpened ? 2000 : 20, onlyOpened ? 0 : pages - (currentPage), onlyOpened ? [{ open: null }] : []));
        }
        console.log(proposals);
        const formattedProposals = proposals.reduce((arr, curr) => {
            return [...arr, {
                    id: curr.id.toString(),
                    title: commands[Object.keys(curr.command_type)[0]],
                    proposed: (0, formatDate_1.formatTime)(curr.id),
                    timeRemaining: (0, formatDate_1.getTimeDiff)(new Date(), new Date(Math.floor(Number(curr.id) / 1000000))),
                    topic: react_1.default.createElement(Chip_1.Chip, { bgColor: "#EDC7F2", color: "#43154A" },
                        react_1.default.createElement("b", null, topics[Object.keys(curr.command_type)[0]])),
                    status: react_1.default.createElement(Chip_1.Chip, { bgColor: "#D9F3C7", color: "#01630A" },
                        react_1.default.createElement("b", null, curr.result && curr.result[0] ? statuses[Object.keys(curr.result[0])[0]] : "Open")),
                    actions: react_1.default.createElement(origyn_art_ui_1.Button, { as: react_router_dom_1.Link, to: `/proposals/${curr.id.toString()}` }, "View"),
                    data: curr,
                }];
        }, []);
        setProposals(formattedProposals.reverse());
        setIsLoading(false);
    };
    const getPages = async () => {
        const metrics = await governanceActor.get_metrics();
        setPages(onlyOpened ? 1 : Math.floor(Number(metrics.proposal_count) / 20));
    };
    (0, react_1.useEffect)(() => {
        if (pages !== 0) {
            getProposals();
        }
    }, [currentPage, pages, onlyOpened]);
    (0, react_1.useEffect)(() => {
        getPages();
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Section_1.Section, null,
            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: "space-between" },
                react_1.default.createElement("h2", null, "Proposals"),
                react_1.default.createElement(origyn_art_ui_1.CheckboxInput, { name: "onlyOpened", checked: onlyOpened, onChange: () => setOnlyOpened(!onlyOpened), label: 'Only Open Proposals' })),
            react_1.default.createElement("br", null),
            isLoading ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(react_1.default.Fragment, null, (proposals.length === 0) ? (react_1.default.createElement(origyn_art_ui_1.Card, null,
                react_1.default.createElement("h6", null, "No active proposals"))) : (react_1.default.createElement(styledComponents_1.TableWrap, null,
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', fullWidth: true },
                    react_1.default.createElement(origyn_art_ui_1.Grid, { style: { marginLeft: 50, minWidth: 900 }, smColumns: cells.length, mdColumns: cells.length, columns: cells.length }, cells.map((c) => react_1.default.createElement("div", null,
                        react_1.default.createElement("b", null, c.label)))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement("br", null),
                    proposals.map((p, index) => {
                        return react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(ProposalBlock, { proposal: p, index: index }));
                    })),
                react_1.default.createElement(origyn_art_ui_1.Pagination, { pageCount: pages, currentPage: currentPage, onPageChange: setCurrentPage }))))))));
};
exports.default = Proposals;
